<template>
  <el-card shadow="never" class="portal-eChart-box">
    <div  class="portal-common-title">
      <span>{{ title }}</span>
      <div style="width: 80px;position: absolute;  top: 13px;    z-index: 10000;   right: 25px;" v-show="isSearch">
        <!-- <el-select v-model="value" placeholder="请选择"  size="small">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select> -->

        <el-date-picker
          style="width: 100px;position: absolute;  top: 13px;    
          z-index: 10000;   right: 25px;"
          v-model="value"
          size="small"
          @change="handleChangeData"
          :clearable="false"
          format="yyyy"
          value-format="yyyy"
          type="year"
          placeholder="选择年">
        </el-date-picker>
      </div>
    </div>
    <div class="eChart-box-body">
      <div ref="regionChart" id="chart" class="dom-canvas" v-show="!isEmpty"></div>
      <div class="portal-common-noData portal-common-noData-eChart" v-show="isEmpty">
        <p class="noData-txt">暂无数据</p>
      </div>
    </div>
  </el-card>
</template>
<script>
import * as echarts from 'echarts'
import resize from '@/components/common/mixins/resize'
import request from '@/config/request.js'
import moment from 'moment'
const ApiHome = request.Home
export default {
  mixins: [resize],
  props: {
    title: { type: String, default: '' },
    option: { type: Object, default: () => {} },
    propsApi: '',
    subTitle: '',
    isSearch:  { type: Boolean, default: false },
  },
  data() {
    return {
      chart: null,
      currOption: {},
      isEmpty: true,
      activeName: 'regionChart',
      value: moment().format('YYYY')
    }
  },
  created() {
    this.getData()
    this.getTableData()
  },
  mounted () {
  },
  methods: {
    getTableData() {
      ApiHome.getZoneStudentByServicePeriod.call(this, {}, (res => {
         this.tableData = res.map(item => ({
          label: item.serviceType,
          value: item.studentNum
        }))
      }))
    },
    handleChangeData() {
      this.getData()
    },
    timeout(ms) {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, ms, 'done')
      })
    },
    getData() {
      ApiHome.getZoneMonthlyNewStudentsByYear.call(this, {year: this.value}, (res => {
        const xAxis = []
        const seriesData = []
        res.items.map(item => {
          xAxis.push(item.month + '月')
          seriesData.push(item.count)
        })
        this.currOption = {
          grid: { left: 60, right: 20, top: 20, bottom: 40 },
          tooltip: { trigger: 'axis' },
          calculable: true,
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: xAxis,
              axisLine: { lineStyle: { color: '#e5e9f2' } },
              axisLabel: { color: '#8b8f96' },
              splitLine: { show: true, lineStyle: { color: '#eef2f6' } }
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLine: { lineStyle: { color: '#e5e9f2' } },
              axisLabel: { color: '#8b8f96' },
              splitLine: { show: true, lineStyle: { color: '#f3f5f7' } }
            }
          ],
          series: [
            {
              name: '新增人数',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 6,
              lineStyle: { color: '#a78bfa', width: 2 },
              itemStyle: {
                color: '#a78bfa',
                borderColor: '#ffffff',
                borderWidth: 1
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(167,139,250,0.20)' },
                  { offset: 1, color: 'rgba(167,139,250,0.05)' }
                ])
              },
              data: seriesData
            }
          ]
        }
        this.timeout(100).then(value => {
          this.initChart()
        })
        this.isEmpty = false
        this.resetChart()
      }))
    },
    initChart(refs) {
      let ref = refs ? refs : this.$refs.regionChart
      this.chart =echarts.init(ref)
      this.chart.setOption(this.currOption)
      setTimeout(() => {
        this.$nextTick(() => {
          this.chart.resize()
        })
      }, 50)
    },
    resetChart() {
      this.isEmpty = JSON.stringify(this.currOption) === '{}'
      this.chart && this.chart.dispose()
      this.chart = null
      this.$nextTick(() => {
        if (!this.isEmpty) this.initChart()
      })
    }
  },
  beforeDestroy() {
    if (!this.chart) return
    this.chart.dispose()
    this.chart = null
  }
}
</script>

<style lang="less">
.el-card__body{
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  .portal-common-title{
    padding: 18px 20px;
    box-sizing: border-box;
  }
  .eChart-box-body {
    flex: 1;
    height: 100%;
    .portal-common-noData-eChart{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .dom-canvas{
    height: 100%;
  }
}


</style>
